import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PiSlidersHorizontalBold } from "react-icons/pi";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { AiFillThunderbolt } from "react-icons/ai";
import axios from "axios";
import { RiArrowLeftWideLine } from "react-icons/ri";
import { RiArrowRightWideLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { addToCart, getCartCount, removeFromCart, editCartProduct } from "../../utils/cartUtils";
import { TbGridDots } from "react-icons/tb";
import Login from "../Layout/Login/Login";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import { FaClock } from "react-icons/fa";



export default function ProductList6({
  data,
  totalItems,
  subcategoryName,
  isReset,
  fetchNextPage,
  hasMore,
  isFetching,
  onResetFilters,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [quantities, setQuantities] = useState({});
  const [selectedFilter, setSelectedFilter] = useState({});
  const [productsPerRow, setProductsPerRow] = useState(3);
  const [productImageAnimation, setProductImageAnimation] =
    useState("Auto Scrolling ");
  const navigate = useNavigate();
  const API_URL =
    `${process.env.REACT_APP_API_BASE_URL}/get_filter_menu`;
  const [products, setProducts] = useState([]);

  const [filterMenus, setFilterMenus] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [sliderValues, setSliderValues] = useState({});
  const dimensionFields = ["Height", "Width", "Depth"];
  const [filtersApplied, setFiltersApplied] = useState(false);
  const displayTitle = filtersApplied ? "Products" : subcategoryName;
  const [cartItems, setCartItems] = useState({});
  const rowOptions = [2, 3, 4, 5];
  const [favorites, setFavorites] = useState({});
  const [vibratingHearts, setVibratingHearts] = useState({});
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const openLoginModal = () => setIsLoginModalOpen(true);
  const closeLoginModal = () => setIsLoginModalOpen(false);
  const [vibratingCarts, setVibratingCarts] = useState({});
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [openSort, setOpenSort] = useState(false);
  const [selectedSizes, setSelectedSizes] = useState({});
  const [cartData, setCartData] = useState([]);
  const [mainCategoryId, setMainCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");



  useEffect(() => {
    fetchCartList();
  }, []);

  const fetchCartList = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_cart_list`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          app_type_id: sessionStorage.getItem("app_type_id"),
          pincode: sessionStorage.getItem("userPincode"),
          user_auto_id: sessionStorage.getItem("accessToken"),
          page_number: 1,
          limit: 10

        }
      );

      if (response.data.status === 1) {
        setCartData(response.data.get_admin_cart_product_lists); // your response name may differ
      }
    } catch (error) {
      console.error("Fetch cart failed", error);
    }
  };


  useEffect(() => {
    if (!cartData.length || !products.length) return;

    const qtyMap = {};
    const cartMap = {};

    products.forEach((product, index) => {
      const cartItem = cartData.find(
        (c) => c.product_auto_id === product.product_auto_id
      );

      if (cartItem) {
        qtyMap[index] = Number(cartItem.cart_quantity);

        cartMap[index] = {
          _id: cartItem._id, // ✅ keep backend key
          product_auto_id: cartItem.product_auto_id,

          user_seleted_size: cartItem.user_seleted_size ?? "N/A",
          product_price: cartItem.product_price,
        };


      }
    });

    setQuantities((prev) => ({ ...prev, ...qtyMap }));
    setCartItems((prev) => ({ ...prev, ...cartMap }));
  }, [cartData, products]);

  useEffect(() => {
    if (!cartData.length || !products.length) return;

    const updatedSizes = {};

    cartData.forEach((cartItem) => {
      const product = products.find(
        (p) => p.id === cartItem.product_auto_id
      );

      if (!product || !product.size?.length) return;

      // 🔁 convert size_auto_id → index
      const sizeIndex = product.size.findIndex(
        (s) => s.size_auto_id === cartItem.user_seleted_size
      );

      if (sizeIndex === -1) return;

      const sizeObj = product.size[sizeIndex];
      const priceObj = product.get_price_lists?.[sizeIndex];

      updatedSizes[product.id] = {
        sizeIndex,
        sizeId: sizeObj.size_auto_id,
        sizeName: sizeObj.size_name,
        price: Number(priceObj?.final_size_price || product.price.replace("₹", "")),
        stock: Number(sizeObj.size_stock),
      };
    });

    setSelectedSizes((prev) => ({
      ...prev,
      ...updatedSizes,
    }));
  }, [cartData, products]);


  useEffect(() => {
    if (!sortOption || products.length === 0) return;

    const sortedList = [...products]; // copy

    if (sortOption === "Price: Low to High") {
      sortedList.sort((a, b) => {
        const pa = parseFloat(a.price.replace("₹", ""));
        const pb = parseFloat(b.price.replace("₹", ""));
        return pa - pb;
      });
    }

    if (sortOption === "Price: High to Low") {
      sortedList.sort((a, b) => {
        const pa = parseFloat(a.price.replace("₹", ""));
        const pb = parseFloat(b.price.replace("₹", ""));
        return pb - pa;
      });
    }

    if (sortOption === "New Arrivals") {
      sortedList.sort((a, b) => {
        const isA = a.badge === "New Arrival";
        const isB = b.badge === "New Arrival";
        return isB - isA; // true → 1, false → 0
      });
    }

    if (sortOption === "Discounts") {
      sortedList.sort((a, b) => {
        const da = a.discount === "No discount" ? 0 : parseFloat(a.discount);
        const db = b.discount === "No discount" ? 0 : parseFloat(b.discount);
        return db - da;
      });
    }

    setProducts(sortedList);
  }, [sortOption]);

  const syncWishlist = async (items) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token || !Array.isArray(items) || items.length === 0) return;

    try {
      const wishlist = await getWishlistProducts();

      const wishlistSet = new Set(
        wishlist.map((w) => String(w.product_auto_id))
      );

      const updatedFavorites = {};
      items.forEach((product) => {
        updatedFavorites[product.id] = wishlistSet.has(
          String(product.product_auto_id)
        );
      });

      setFavorites(updatedFavorites);
    } catch (error) {
      console.error("Wishlist sync failed:", error);
    }
  };

  useEffect(() => {
    if (products.length > 0) {
      syncWishlist(products);
    }
  }, [products]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour)
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  const toggleFavorite = async (id, productId) => {
    const customerId = sessionStorage.getItem("accessToken");
    if (!customerId) {
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => {
        setVibratingHearts((prev) => ({ ...prev, [id]: false }));
        openLoginModal();
      }, 500);
      return;
    }

    const isNowFavorite = !favorites[id];
    setFavorites((prev) => ({ ...prev, [id]: isNowFavorite }));

    try {
      if (isNowFavorite) {
        await addToWishlist(productId);
      } else {
        await removeFromWishlist(productId);
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
      setFavorites((prev) => ({ ...prev, [id]: !isNowFavorite }));
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => setVibratingHearts((prev) => ({ ...prev, [id]: false })), 500);
    }
  };

  const handleChangeRowProductsPerRow = () => {
    setProductsPerRow((prevRow) => {
      const currentIndex = rowOptions.indexOf(prevRow);
      const nextIndex = (currentIndex + 1) % rowOptions.length; // Cycle through options
      return rowOptions[nextIndex];
    });
  };




  const mapProducts = (data) => {
    const baseUrl =
      "https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/";

    return data.map((product) => ({
      id: product.product_auto_id,
      product_auto_id: product.product_auto_id,
      title: product.product_name || "Unknown Product",
      description: product.description || "No description available",
      weight: product.unit || "N/A",
      price: `₹${product.final_product_price || "0"}`,
      originalPrice: `₹${product.product_price || "0"}`,
      discount: product.offer_percentage
        ? `${product.offer_percentage}% off`
        : "No discount",
      delivery:
        product.time && product.time_unit
          ? `Delivery in ${product.time} ${product.time_unit}`
          : "Delivery time unavailable",
      images:
        product.product_images?.map(
          (img) => `${baseUrl}${img.product_image}`
        ) || [],
      size: product.size || [],
      get_price_lists: product.get_price_lists || [],
      moq: product.moq || 1,
    }));
  };

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {

      // Capture category context once
      setMainCategoryId(data[0]?.main_category_auto_id || "");
      setSubCategoryId(data[0]?.sub_category_auto_id || "");

      const mapped = mapProducts(data);
      setProducts((prev) => {
        if (isReset) {
          return mapped;
        } else {
          const existingIds = new Set(prev.map(p => p.product_auto_id));
          const newProducts = mapped.filter(p => !existingIds.has(p.product_auto_id));
          return [...prev, ...newProducts];
        }
      });
    }
  }, [data]);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axios.post(API_URL, {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
        });

        if (response.data.status === 1) {
          const data1 = response.data;

          // Prepare a map for quick lookup
          const priceRange =
            data1.price_list && data1.price_list.length > 0
              ? {
                min: parseFloat(data1.price_list[0].min_price),
                max: parseFloat(data1.price_list[0].max_price),
              }
              : { min: 0, max: 100000 };

          const processedMenus = data1.allfiltermenus.map((menu) => {
            let type = "select";
            let options = [];
            let sliderRange = null;

            switch (menu.filter_menu_name) {
              case "Price":
                type = "slider";
                sliderRange = priceRange;
                break;

              case "Thickness":
                type = "slider";
                break;

              case "Manufacturers":
                options =
                  data1.manufacturer_list?.map((item) => ({
                    label: item.manufacturer_name,
                    value: item._id,
                  })) || [];
                break;

              case "Size":
                options =
                  data1.size_list?.map((item) => ({
                    label: item.size,
                    value: item.size_auto_id,
                  })) || [];
                break;

              case "Brand":
                options =
                  data1.brand_list?.map((item) => ({
                    label: item.brand_name,
                    value: item.brand_auto_id,
                  })) || [];
                break;

              case "Color":
                options =
                  data1.color_list?.map((item) => ({
                    label: item.color_name,
                    value: item._id,
                  })) || [];
                break;

              case "Material":
                options =
                  data1.material_list?.map((item) => ({
                    label: item.material_name,
                    value: item._id,
                  })) || [];
                break;

              case "Discount":
                options =
                  data1.discount_list?.map((item) => ({
                    label: `${item.discount_percent}%`,
                    value: item._id,
                  })) || [];
                break;

              case "Firmness":
                options =
                  data1.firmness_list?.map((item) => ({
                    label: item.unit,
                    value: item._id,
                  })) || [];
                break;

              case "Out of stock":
                options = [{ label: "Include out of stock", value: true }];
                break;

              case "Moq":
                options = Array.from({ length: 10 }, (_, i) => ({
                  label: (i + 1).toString(),
                  value: i + 1,
                }));
                break;

              default:
                options = [];
            }

            return {
              name: menu.filter_menu_name,
              type,
              options,
              sliderRange,
            };
          });

          // Check if Dimension already exists
          const dimensionExists = processedMenus.some(
            (menu) => menu.name.toLowerCase() === "dimension"
          );

          if (!dimensionExists) {
            const dimensionFilter = {
              name: "Dimension",
              type: "dimension-group", // special type
              options: [
                { name: "Height", type: "slider" },
                { name: "Width", type: "slider" },
                { name: "Depth", type: "slider" },
              ],
            };

            processedMenus.push(dimensionFilter);
          }

          setFilterMenus(processedMenus);

          // Default selected filter
          setSelectedFilter(
            processedMenus.length > 0 ? processedMenus[0].name : "Dimension"
          );
        } else {
          console.error("Failed to fetch filters");
        }
      } catch (error) {
        console.error("Error fetching filters:", error);
      }
    };

    fetchFilters();
  }, []);

  const handleOptionToggle = (filterName, optionValue) => {
    setSelectedOptions((prev) => {
      const prevSelected = prev[filterName] || [];
      if (prevSelected.includes(optionValue)) {
        return {
          ...prev,
          [filterName]: prevSelected.filter((v) => v !== optionValue),
        };
      } else {
        return {
          ...prev,
          [filterName]: [...prevSelected, optionValue],
        };
      }
    });
  };

  const handleSliderChange = (filterName, key, value) => {
    // Allow empty string to let user clear the input box temporarily
    if (value === "") {
      setSliderValues((prev) => ({
        ...prev,
        [filterName]: {
          ...prev[filterName],
          [key]: "",
        },
      }));
      return;
    }

    // Convert to number safely
    const numericValue = Number(value);
    if (isNaN(numericValue)) {
      // Invalid number, ignore or handle accordingly
      return;
    }

    setSliderValues((prev) => ({
      ...prev,
      [filterName]: {
        ...prev[filterName],
        [key]: numericValue,
      },
    }));
  };

  // Clear all selections
  const clearFilters = () => {
    setSelectedOptions({});
    setSliderValues({});
    setFiltersApplied(false);

    setProducts([]);
    onResetFilters?.();
  };

  const applyFilters = async () => {
    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
    const app_type_id = sessionStorage.getItem("app_type_id");
    const user_auto_id =
      sessionStorage.getItem("accessToken") ||
      sessionStorage.getItem("admin_auto_id");
    const country = localStorage.getItem("country_name") || "India";

    const formData = new FormData();
    formData.append("admin_auto_id", admin_auto_id);
    formData.append("app_type_id", app_type_id);
    formData.append("customer_auto_id", user_auto_id);
    formData.append("country", country);
    formData.append("limit", 10);
    formData.append("page_number", 1);
    formData.append("main_category_id", mainCategoryId);
    formData.append("sub_category_id", subCategoryId);

    // Handle select/multi-select filters from selectedOptions
    Object.entries(selectedOptions).forEach(([filterName, values]) => {
      if (!values || values.length === 0) return;

      const joinedValues = values.join("|"); // Pipe-separated string

      switch (filterName) {
        case "Brand":
          formData.append("brand_id", joinedValues);
          break;

        case "Size":
          formData.append("size_id", joinedValues);
          break;

        case "Manufacturers":
          const manufacturerLabels = filterMenus
            .find((f) => f.name === "Manufacturers")
            ?.options.filter((opt) => values.includes(opt.value))
            .map((opt) => opt.label);
          if (manufacturerLabels?.length)
            formData.append("manufacturer_name", manufacturerLabels.join("|"));
          break;

        case "Material":
          const materialLabels = filterMenus
            .find((f) => f.name === "Material")
            ?.options.filter((opt) => values.includes(opt.value))
            .map((opt) => opt.label);
          if (materialLabels?.length)
            formData.append("material_name", materialLabels.join("|"));
          break;

        case "Firmness":
          const firmnessLabels = filterMenus
            .find((f) => f.name === "Firmness")
            ?.options.filter((opt) => values.includes(opt.value))
            .map((opt) => opt.label);
          if (firmnessLabels?.length)
            formData.append("firmness_type", firmnessLabels.join("|"));
          break;

        case "Color":
          const colorLabels = filterMenus
            .find((f) => f.name === "Color")
            ?.options.filter((opt) => values.includes(opt.value))
            .map((opt) => opt.label);
          if (colorLabels?.length)
            formData.append("color_name", colorLabels.join("|"));
          break;

        case "Out of stock":
          if (values.includes(true) || values.includes("true"))
            formData.append("out_of_stock", true);
          break;

        case "Discount":
          const discountLabels = filterMenus
            .find((f) => f.name === "Discount")
            ?.options.filter((opt) => values.includes(opt.value))
            .map((opt) => opt.label);
          if (discountLabels?.length) {
            const maxDiscount = parseInt(discountLabels[0]);
            formData.append("min_discount", 0);
            formData.append("max_discount", maxDiscount);
          }
          break;

        case "Moq":
          const moqLabels = filterMenus
            .find((f) => f.name === "Moq")
            ?.options.filter((opt) => values.includes(opt.value))
            .map((opt) => opt.label);
          if (moqLabels?.length) {
            formData.append("moq", moqLabels[0]);
          }
          break;

        default:
          break;
      }
    });

    // Handle sliders from sliderValues (including Dimension group)
    // Example keys: Price, Height, Width, Depth, Thickness, Thickness etc.

    // Price slider
    if (
      sliderValues.Price &&
      sliderValues.Price.min !== "" &&
      sliderValues.Price.max !== ""
    ) {
      formData.append("min_price", sliderValues.Price.min);
      formData.append("max_price", sliderValues.Price.max);
    }

    // Thickness slider
    if (
      sliderValues.Thickness &&
      sliderValues.Thickness.min !== "" &&
      sliderValues.Thickness.max !== ""
    ) {
      formData.append("min_thickness", sliderValues.Thickness.min);
      formData.append("max_thickness", sliderValues.Thickness.max);
    }

    // Dimension sliders: height, width, depth
    if (
      sliderValues.Height &&
      sliderValues.Height.min !== "" &&
      sliderValues.Height.max !== ""
    ) {
      formData.append("min_height", sliderValues.Height.min);
      formData.append("max_height", sliderValues.Height.max);
    }

    if (
      sliderValues.Width &&
      sliderValues.Width.min !== "" &&
      sliderValues.Width.max !== ""
    ) {
      formData.append("min_width", sliderValues.Width.min);
      formData.append("max_width", sliderValues.Width.max);
    }

    if (
      sliderValues.Depth &&
      sliderValues.Depth.min !== "" &&
      sliderValues.Depth.max !== ""
    ) {
      formData.append("min_depth", sliderValues.Depth.min);
      formData.append("max_depth", sliderValues.Depth.max);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_filter_products`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === 1) {
        const data2 = response.data.get_admin_filter_product_lists;
        const baseUrl =
          "https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/";

        const mappedProducts = data2.map((product, index) => ({
          id: index,
          product_auto_id: product.product_auto_id,
          title: product.product_name || "Unknown Product",
          description: product.description || "No description available",
          weight: product.unit || "N/A",
          price: `₹${product.final_product_price || "0"}`,
          originalPrice: `₹${product.product_price || "0"}`,
          discount: product.offer_percentage
            ? `${product.offer_percentage}% off`
            : "No discount",
          delivery:
            product.time && product.time_unit
              ? `Delivery in ${product.time} ${product.time_unit}`
              : "Delivery time unavailable",
          images:
            product.product_images?.map(
              (img) => `${baseUrl}${img.product_image}`
            ) || [],

          size: product.size || [],
          get_price_lists: product.get_price_lists || [],
          moq: product.moq || 1
        }));

        setProducts(mappedProducts);
        setFiltersApplied(true);
      } else {
        setProducts([]);
        setFiltersApplied(true);
      }
    } catch (error) {
      console.error("Error applying filters:", error);
    }
  };

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);

      setProductsPerRow(parseInt(parsedStyle.product_per_row));
      setProductImageAnimation(parsedStyle.product_image_animation);
    }
  }, []);


  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 1500 &&
        !isFetching &&
        hasMore
      ) {
        fetchNextPage(); // ← This comes from props
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [fetchNextPage, isFetching, hasMore]);

  const handleAddClick = async (index) => {
    const accessToken = sessionStorage.getItem("accessToken");
    const product = products[index];

    if (!accessToken) {
      openLoginModal();
      return;
    }

    // ✅ SIZE VALIDATION
    if (product.size?.length && !selectedSizes[product.id]) {
      alert("Please select size");
      return;
    }

    const selectedSize = selectedSizes[product.id];

    const payload = {
      product_auto_id: product.product_auto_id,
      added_by_id: accessToken,
      cart_quantity: product.moq ? parseInt(product.moq) : 1,

      // ✅ SIZE HANDLING
      size:
        product.size?.length > 0
          ? selectedSize?.sizeId ?? "N/A"
          : "N/A",

      size_price:
        product.size?.length > 0
          ? selectedSize?.price ?? product.price.replace("₹", "")
          : product.price.replace("₹", ""),
    };


    try {
      const response = await addToCart(payload);

      if (response.status === "1") {
        setCartData((prev) => [
          ...prev,
          {
            _id: response.data?._id || Date.now(),
            product_auto_id: product.product_auto_id,
            cart_quantity: payload.cart_quantity,

            // ✅ cart list uses this name
            user_seleted_size: payload.size,
            product_price: payload.size_price,
          },
        ]);

        setQuantities((prev) => ({
          ...prev,
          [index]: payload.cart_quantity,
        }));
      }
    } catch (error) {
      console.error("Add to cart failed", error);
    }
  };


  const updateCartWithSizeAndPrice = async (cartItem, newQuantity) => {
    try {
      await editCartProduct({
        cart_product_auto_id: cartItem._id,
        cart_quantity: newQuantity,

        // ✅ fallback for no size
        size: cartItem.user_seleted_size ?? "N/A",
        size_price: cartItem.product_price,
      });


    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };




  const handleIncrement = (index) => {
    const newQuantity = (quantities[index] || 0) + 1;
    setQuantities((prev) => ({ ...prev, [index]: newQuantity }));

    const cartItem = cartItems[index];
    if (cartItem) {
      updateCartWithSizeAndPrice(cartItem, newQuantity);
    }
  };


  const handleDecrement = async (index) => {
    const newQuantity = (quantities[index] || 0) - 1;
    const cartItem = cartItems[index];
    // For updating quantity
    const productId = cartItem?.product_auto_id;
    // For removing from cart

    if (newQuantity <= 0) {
      setQuantities((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });

      setCartItems((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });

      if (productId) {
        try {
          await removeFromCart(productId); // Send product_auto_id here
        } catch (error) {
          console.error("Error removing from cart:", error);
        }
      }
    } else {
      setQuantities((prev) => ({ ...prev, [index]: newQuantity }));

      if (cartItem) {
        updateCartWithSizeAndPrice(cartItem, newQuantity);
      }
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: productImageAnimation === "Auto Scrolling",
    autoplaySpeed: 3000,
    appendDots: (dots) => (
      <div style={{ position: "absolute", bottom: "0.1rem", width: "100%" }}>
        <ul style={{ display: "flex", justifyContent: "center" }}> {dots} </ul>
      </div>
    ),
    customPaging: () => (
      <div className="w-3 h-2 bg-white rounded-full opacity-70 hover:opacity-100"></div>
    ),

    arrows: productImageAnimation === "On Arrow Click",
  };

  const [currentImageIndex, setCurrentImageIndex] = useState({});

  // Handle previous image click
  const handlePrevImage = (productId) => {
    setCurrentImageIndex((prevState) => {
      const currentIndex = prevState[productId] || 0; // Default to 0 if not set
      const newIndex =
        currentIndex === 0
          ? products[productId].images.length - 1
          : currentIndex - 1;
      return { ...prevState, [productId]: newIndex };
    });
  };

  const handleNextImage = (productId) => {
    setCurrentImageIndex((prevState) => {
      const currentIndex = prevState[productId] || 0;
      const newIndex =
        currentIndex === products[productId].images.length - 1
          ? 0
          : currentIndex + 1;
      return { ...prevState, [productId]: newIndex };
    });
  };

  const [imageIntervals, setImageIntervals] = useState({});

  const handleHoverStart = (productId) => {
    if (!products[productId]?.images?.length) return; // Prevent errors

    let index = 0;
    const interval = setInterval(() => {
      setCurrentImageIndex((prevState) => ({
        ...prevState,
        [productId]: index,
      }));

      index = (index + 1) % products[productId].images.length; // Loop images
    }, 1300); // Change image every 1 second

    setImageIntervals((prevState) => ({
      ...prevState,
      [productId]: interval,
    }));
  };

  const handleHoverEnd = (productId) => {
    clearInterval(imageIntervals[productId]); // Stop changing images
    setCurrentImageIndex((prevState) => ({
      ...prevState,
      [productId]: 0, // Reset to first image
    }));
    setImageIntervals((prevState) => {
      const newState = { ...prevState };
      delete newState[productId];
      return newState;
    });
  };

  return (
    <div className={`${webFont}`}>
      <style>
        {`
          @keyframes slideLeft {
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
  }
  .animate-slide-left {
    animation: slideLeft 0.3s ease-out;
  }
          @keyframes vibrate {
            0% { transform: translate(0); }
            20% { transform: translate(-2px, 2px); }
            40% { transform: translate(-2px, -2px); }
            60% { transform: translate(2px, 2px); }
            80% { transform: translate(2px, -2px); }
            100% { transform: translate(0); }
          }
          .vibrate {
            animation: vibrate 0.3s linear;
          }
            
        `}
      </style>
      <div className="hidden p-2 py-6 sm:px-4 md:px-44 md:block" style={{ backgroundColor: lightenHexColor(themeColor, 0.1) }}>
        <div className="mb-2 text-sm text-gray-500">
          Home / <span style={{ color: darkenHexColor(themeColor, 0.2) }}>{displayTitle}</span>
        </div>
        <h2 className="text-2xl font-bold">{displayTitle}</h2>
      </div>
      <div className="p-0 mt-0 md:mt-2 md:p-2 sm:px-4 md:px-44">


        <div
          className="
    flex bg-gray-100 items-center justify-between  border-b  md:bg-white z-50
    fixed w-full px-2 py-2      /* mobile fixed */
    md:static md:bottom-auto md:left-auto md:w-auto  /* desktop normal */
  "
        >

          <h5 className="hidden md:block">{totalItems} Items</h5>

          <div className="flex-1 block text-center md:hidden">

            {/* SORT BY */}
            <div
              className="cursor-pointer"
              onClick={() => setOpenSort(true)}
            >
              <span className="text-lg font-bold text-black">
                SORT BY
              </span>
            </div>

            {/* Bottom dropdown */}
            {openSort && (
              <div className="fixed bottom-10 left-0 w-full bg-white text-black p-4 z-[999]">

                {/* Header with close button */}
                <div className="relative flex items-center mb-3">

                  {/* Centered SORT BY */}
                  <span className="absolute font-semibold -translate-x-1/2 left-1/2">
                    SORT BY
                  </span>

                  {/* Close button on right */}
                  <span
                    className="ml-auto text-xl cursor-pointer"
                    onClick={() => setOpenSort(false)}
                  >
                    ✕
                  </span>

                </div>


                <div
                  className="py-2 text-center"
                  onClick={() => { setSortOption("Price: Low to High"); setOpenSort(false); }}
                >
                  Price: Low to High
                </div>

                <div
                  className="py-2 text-center"
                  onClick={() => { setSortOption("Price: High to Low"); setOpenSort(false); }}
                >
                  Price: High to Low
                </div>

                <div
                  className="py-2 text-center"
                  onClick={() => { setSortOption("New Arrivals"); setOpenSort(false); }}
                >
                  New Arrivals
                </div>

                <div
                  className="py-2 text-center"
                  onClick={() => { setSortOption("Discounts"); setOpenSort(false); }}
                >
                  Discounts
                </div>

              </div>
            )}

          </div>




          <div className="relative inline-flex items-center gap-2">
            <div className="relative inline-block text-left">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-1 px-4 py-1 text-lg font-semibold text-black "
              >
                <PiSlidersHorizontalBold />
                FILTER
              </button>


              {isOpen && (
                <div
                  className="
    fixed top-0 right-0 h-[92%] md:h-full w-full md:w-80 
    z-50 bg-white shadow-xl border-l 
    flex flex-col 
    animate-slide-left
  "
                >



                  <div className="flex flex-grow py-0 pl-0 h-[40vh] md:h-[65vh]">
                    {/* Left sidebar */}
                    <div
                      className="w-full max-h-full pr-4 overflow-y-auto border-r"
                      style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                    >
                      <style>
                        {`
                    /* Hide scrollbar for Chrome, Safari and Opera */
                    .no-scrollbar::-webkit-scrollbar {
                      display: none;
                    }
                    /* Hide scrollbar for IE, Edge and Firefox */
                    .no-scrollbar {
                      -ms-overflow-style: none;  /* IE and Edge */
                      scrollbar-width: none;  /* Firefox */
                    }
                  `}
                      </style>
                      <ul className="pl-2 space-y-3 font-semibold text-gray-700 no-scrollbar">
                        {filterMenus.map(({ name }) => (
                          <li
                            key={name}
                            className={`cursor-pointer p-2 relative ${selectedFilter === name
                              ? ""
                              : "hover:bg-gray-200"
                              }`}
                            style={{ color: selectedFilter === name ? themeColor : "" }}
                            onClick={() => setSelectedFilter(name)}
                          >
                            {selectedFilter === name && (
                              <div className="absolute top-0 bottom-0 left-0 w-1 "></div>
                            )}
                            {name}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Right panel */}
                    <div className="w-full max-h-full pl-4 pr-2 overflow-y-auto no-scrollbar">
                      {selectedFilter === "Dimension" ? (
                        <div className="flex flex-col space-y-4">
                          {dimensionFields.map((dim) => {
                            // Use sliderValues if set, else fallback to sliderRange on dimensionFilter
                            const dimensionFilter = filterMenus.find(
                              (f) => f.name === "Dimension"
                            );
                            const dimOption = dimensionFilter?.options.find(
                              (o) => o.name === dim
                            );
                            const defaultMin = dimOption?.sliderRange?.min ?? 0;
                            const defaultMax =
                              dimOption?.sliderRange?.max ?? 1000;

                            const values = sliderValues[dim] || {
                              min: defaultMin,
                              max: defaultMax,
                            };
                            return (
                              <div key={dim}>
                                <label className="font-semibold text-gray-700">
                                  {dim}
                                </label>
                                <div className="flex items-center space-x-2">
                                  <input
                                    type="number"
                                    value={values.min}
                                    min={defaultMin}
                                    max={values.max}
                                    onChange={(e) =>
                                      handleSliderChange(
                                        dim,
                                        "min",
                                        e.target.value
                                      )
                                    }
                                    className="w-16 px-1 border rounded"
                                  />
                                  <span>-</span>
                                  <input
                                    type="number"
                                    value={values.max}
                                    min={values.min}
                                    max={defaultMax}
                                    onChange={(e) =>
                                      handleSliderChange(
                                        dim,
                                        "max",
                                        e.target.value
                                      )
                                    }
                                    className="w-16 px-1 border rounded"
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        (() => {
                          const current = filterMenus.find(
                            (f) => f.name === selectedFilter
                          );
                          if (!current) return null;

                          if (current.type === "select") {
                            return current.options.map(({ label, value }) => (
                              <label
                                key={value}
                                className="flex items-center w-full mb-3 space-x-2 cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedOptions[selectedFilter]?.includes(
                                      value
                                    ) || false
                                  }
                                  onChange={() =>
                                    handleOptionToggle(selectedFilter, value)
                                  }
                                  className="form-checkbox"
                                />
                                <span>{label}</span>
                              </label>
                            ));
                          }

                          if (current.type === "slider") {
                            const defaultMin = current.sliderRange?.min ?? 0;
                            const defaultMax = current.sliderRange?.max ?? 1000;

                            const values = sliderValues[selectedFilter] || {
                              min: defaultMin,
                              max: defaultMax,
                            };

                            return (
                              <div className="space-y-2">
                                <label className="font-semibold text-gray-700">
                                  {selectedFilter}
                                </label>
                                <div className="flex items-center space-x-2">
                                  <input
                                    type="number"
                                    value={values.min}
                                    min={defaultMin}
                                    max={values.max}
                                    onChange={(e) =>
                                      handleSliderChange(
                                        selectedFilter,
                                        "min",
                                        e.target.value
                                      )
                                    }
                                    className="w-16 px-1 border rounded"
                                  />
                                  <span>-</span>
                                  <input
                                    type="number"
                                    value={values.max}
                                    min={values.min}
                                    max={defaultMax}
                                    onChange={(e) =>
                                      handleSliderChange(
                                        selectedFilter,
                                        "max",
                                        e.target.value
                                      )
                                    }
                                    className="w-16 px-1 border rounded"
                                  />
                                </div>
                              </div>
                            );
                          }
                        })()
                      )}
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="flex justify-center gap-4 px-4 py-3 bg-white border-t">
                    <button
                      className="w-32 py-2 font-semibold text-center border border-gray-300 rounded-lg hover:bg-gray-100"
                      onClick={() => {
                        clearFilters();
                        setIsOpen(false);
                      }}
                      style={{ color: themeColor }}
                    >
                      CLOSE
                    </button>

                    <button
                      className="w-32 py-2 font-semibold text-center text-white rounded-lg"
                      onClick={() => {
                        applyFilters();
                        setIsOpen(false);
                      }}
                      style={{ backgroundColor: themeColor }}
                      onMouseEnter={(e) => {
                        const darkenedColor = darkenHexColor(themeColor, 0.15);
                        e.currentTarget.style.backgroundColor = darkenedColor;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = themeColor;
                      }}
                    >
                      APPLY FILTER
                    </button>
                  </div>


                </div>
              )}
            </div>
            {/* Grid Toggle Button */}
            <button onClick={handleChangeRowProductsPerRow} title="Change Grid Layout" className="p-2 text-black border border-gray-300 rounded-full hover:bg-gray-200 " > <TbGridDots size={24} /> </button>


          </div>
          {/* <button
  onClick={handleChangeRowProductsPerRow}
  title="Change Grid Layout"
  className="flex items-center justify-center flex-1 block w-12 p-2 hover:bg-gray-200 md:hidden md:flex-none"
>
  <div className="relative w-full h-1 bg-gray-400 rounded">
    
    <div
      className={`absolute top-[-6px] w-[3px] h-4 bg-gray-500 transition-all duration-300`}
      style={{
        left:
          productsPerRow === 2 ? "5%" :
          productsPerRow === 3 ? "35%" :
          productsPerRow === 4 ? "65%" :
          "90%"
      }}
    ></div>
  </div>
</button> */}
        </div>

        <div className="top-0 p-6"></div>
        {/* No Products Found */}
        {!isFetching && filtersApplied && products.length === 0 && (
          <div className="flex flex-col items-center justify-center py-20 text-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/7486/7486740.png"
              alt="No products"
              className="mb-4 w-28 h-28 opacity-70"
            />

            <h2 className="text-xl font-semibold text-gray-700">
              No products found
            </h2>

            <p className="mt-2 text-gray-500">
              Try adjusting your filters or clear them to see products.
            </p>

            <button
              onClick={clearFilters}
              className="px-6 py-2 mt-4 text-white rounded-md"
              style={{ backgroundColor: themeColor }}
            >
              Clear Filters
            </button>
          </div>
        )}


        {/* 2  products per row */}
        {productsPerRow === 2 && (
          <div className="container px-1 py-6 mx-auto">
            <div className="grid grid-cols-2 gap-4 md:grid-cols-2 lg:grid-cols-2">
              {products.map((product, index) => (
                <div
                  key={index}
                  className="relative bg-white border rounded-xl p-3 h-[460px] flex flex-col overflow-hidden"
                >
                  {/* Discount Badge */}
                  {product.discount &&
                    parseFloat(product.discount.replace("% off", "")) > 0 && (
                      <div className="absolute left-0 z-10 px-3 py-1 text-xs font-bold text-white bg-green-700 rounded-r-full top-2">
                        {product.discount}
                      </div>
                    )}

                  {/* IMAGE SECTION */}
                  <div className="relative p-3 mb-3 rounded-lg bg-gray-50">
                    {/* =============== Your Existing Image Animations =============== */}
                    {productImageAnimation === "Auto Scrolling" && product.images.length > 1 ? (
                      <Slider {...settings}>
                        {product.images.map((src, imgIndex) => (
                          <div key={imgIndex} className="relative">
                            <img
                              src={src}
                              alt={product.title}
                              className="object-contain w-full h-40 cursor-pointer"
                              onClick={() =>
                                navigate(`/product-detail/${product.product_auto_id}`)
                              }
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : productImageAnimation === "On Arrow Click" ? (
                      <div className="relative">
                        {/* Left Arrow */}
                        {product.images.length > 1 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePrevImage(product.id);
                            }}
                            className="absolute left-0 z-10 p-2 ml-2 text-white transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full top-1/2"
                          >
                            <RiArrowLeftWideLine />
                          </button>
                        )}

                        <img
                          src={
                            product.images[currentImageIndex[product.id] || 0] ||
                            "https://placehold.co/300x400"
                          }
                          alt={product.title}
                          className="object-contain w-full h-40 cursor-pointer"
                          onClick={() =>
                            navigate(`/product-detail/${product.product_auto_id}`)
                          }
                        />

                        {/* Right Arrow */}
                        {product.images.length > 1 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNextImage(product.id);
                            }}
                            className="absolute right-0 z-10 p-2 mr-2 text-white transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full top-1/2"
                          >
                            <RiArrowRightWideLine />
                          </button>
                        )}
                      </div>
                    ) : productImageAnimation === "On Hover Scrolling" ? (
                      <div
                        className="relative"
                        onMouseEnter={() => handleHoverStart(product.id)}
                        onMouseLeave={() => handleHoverEnd(product.id)}
                      >
                        <img
                          src={
                            product.images[currentImageIndex[product.id] || 0] ||
                            "https://placehold.co/300x400"
                          }
                          alt={product.title}
                          className="object-contain w-full h-40 cursor-pointer"
                          onClick={() =>
                            navigate(`/product-detail/${product.product_auto_id}`)
                          }
                        />
                      </div>
                    ) : (
                      <img
                        src={product.images?.[0] || "https://placehold.co/300x400"}
                        alt={product.title}
                        className="object-contain w-full h-40 cursor-pointer"
                        onClick={() => navigate(`/product-detail/${product.product_auto_id}`)}
                      />
                    )}



                  </div>
                  {/* Delivery Pill (above fresho! and on right side) */}
                  {product.delivery &&
                    product.delivery !== "Delivery time unavailable" &&
                    product.delivery !== "Delivery time unavailabl" && (
                      <div className="flex justify-end mb-2">
                        <div className="hidden md:inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#FFF4D6] text-[#8A6A00] text-xs font-semibold whitespace-nowrap">
                          <FaClock className="text-xs" />
                          <span>{product.delivery}</span>
                        </div>
                      </div>
                    )}

                  {/* Brand (static like Product6) */}
                  <p className="mb-1 text-sm text-gray-500">fresho!</p>

                  {/* Product Name */}
                  <h3 className="mb-1 text-sm font-medium leading-snug line-clamp-2">
                    {product.title}
                  </h3>


                  {/* Size Dropdown */}
                  {product.size && product.size.length > 0 && (
                    <select
                      className="px-2 py-1 mb-2 text-sm text-black bg-white border rounded-md"
                      value={selectedSizes[product.id]?.sizeIndex ?? ""}

                      onChange={(e) => {
                        const index = Number(e.target.value);

                        const sizeObj = product.size[index];
                        const priceObj = product.get_price_lists[index];


                        setSelectedSizes((prev) => ({
                          ...prev,
                          [product.id]: {
                            sizeIndex: index,
                            sizeId: sizeObj.size_auto_id, // real ID (for cart)
                            sizeName: sizeObj.size_name,
                            price: Number(priceObj?.final_size_price || product.price.replace("₹", "")),

                            stock: Number(sizeObj.size_stock),

                          },
                        }));
                      }}


                    >
                      <option value="" disabled>
                        Select size
                      </option>

                      {product.size.map((s, index) => (
                        <option
                          key={s.size_auto_id}
                          value={index}
                          disabled={Number(s.size_stock) <= 0}
                        >
                          {s.size_name}
                        </option>
                      ))}
                    </select>
                  )}

                  {/* Price */}
                  <div className="mb-2">
                    <p className="text-sm font-semibold text-black">
                      ₹{selectedSizes[product.id]?.price ?? product.price.replace("₹", "")}

                      {product.originalPrice && (
                        <span className="ml-2 text-gray-400 line-through">
                          {product.originalPrice}
                        </span>
                      )}
                    </p>
                  </div>

                  {/* Bottom Actions (Wishlist + Add/Qty) */}
                  <div className="flex items-center gap-2 mt-auto">
                    {/* Wishlist (same logic) */}
                    <button
                      className={`p-1 rounded-full ${vibratingHearts[product.id] ? "vibrate" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFavorite(product.id, product.product_auto_id);
                      }}
                    >
                      {favorites[product.id] ? (
                        <FaHeart className="w-5 h-5 text-red-500 transition-colors duration-200" />
                      ) : (
                        <FaRegHeart className="w-5 h-5 text-gray-500 transition-colors duration-200" />
                      )}
                    </button>

                    {/* Add / Quantity */}
                    <div className="flex-1">
                      {quantities[index] !== undefined ? (
                        <div className="flex items-center justify-between w-full px-2 py-1 border rounded-md">
                          <div className="flex items-center justify-center w-full gap-2">
                            {/* Minus */}
                            <button
                              className="px-2 py-1 border rounded"
                              onClick={() => handleDecrement(index)}
                              style={{ color: themeColor }}
                            >
                              <AiOutlineMinus size={14} />
                            </button>

                            {/* Quantity input */}
                            <input
                              type="number"
                              min="0"
                              value={quantities[index] ?? ""}
                              onChange={async (e) => {
                                const rawValue = e.target.value;

                                if (rawValue === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: "",
                                  }));
                                  return;
                                }

                                const value = parseInt(rawValue);
                                if (!isNaN(value)) {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: value,
                                  }));

                                  const cartItem = cartItems[index];

                                  const productId = cartItem?.product_auto_id;


                                  if (value === 0) {
                                    setQuantities((prev) => {
                                      const updated = { ...prev };
                                      delete updated[index];
                                      return updated;
                                    });

                                    setCartItems((prev) => {
                                      const updated = { ...prev };
                                      delete updated[index];
                                      return updated;
                                    });

                                    if (productId) {
                                      try {
                                        await removeFromCart(productId);
                                      } catch (error) {
                                        console.error("Error removing from cart:", error);
                                      }
                                    }
                                  } else if (cartItem) {
                                    updateCartWithSizeAndPrice(cartItem, value);
                                  }

                                }
                              }}
                              onBlur={() => {
                                if (quantities[index] === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: 1,
                                  }));
                                  const cartItem = cartItems[index];
                                  if (cartItem) {
                                    updateCartWithSizeAndPrice(cartItem, 1);
                                  }

                                }
                              }}
                              className="w-10 text-sm font-semibold text-center bg-transparent outline-none"
                            />

                            {/* Plus */}
                            <button
                              className="px-2 py-1 border rounded"
                              onClick={() => handleIncrement(index)}
                              style={{ color: themeColor }}
                            >
                              <AiOutlinePlus size={14} />
                            </button>
                          </div>
                        </div>
                      ) : (
                        <button
                          className={`w-full py-2 font-semibold border rounded-md ${vibratingCarts[product.id] ? "vibrate" : ""
                            }`}
                          onClick={() => handleAddClick(index)}
                          style={{
                            borderColor: themeColor,
                            color: themeColor,
                            backgroundColor: "transparent",
                          }}
                          onMouseEnter={(e) => {
                            const darkenedColor = darkenHexColor(themeColor, 0.15);
                            e.currentTarget.style.backgroundColor = darkenedColor;
                            e.currentTarget.style.color = "#fff";
                            e.currentTarget.style.borderColor = darkenedColor;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                            e.currentTarget.style.color = themeColor;
                            e.currentTarget.style.borderColor = themeColor;
                          }}
                        >
                          Add
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        )}

        {/* 3 products per row */}
        {productsPerRow === 3 && (
          <div className="container px-1 py-4 mx-auto">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {products.map((product, index) => (
                <div
                  key={index}
                  className="relative bg-white border rounded-xl p-3 h-[460px] flex flex-col overflow-hidden"
                >
                  {/* Discount Badge */}
                  {product.discount &&
                    parseFloat(product.discount.replace("% off", "")) > 0 && (
                      <div className="absolute left-0 z-10 px-3 py-1 text-xs font-bold text-white bg-green-700 rounded-r-full top-2">
                        {product.discount}
                      </div>
                    )}

                  {/* IMAGE SECTION */}
                  <div className="relative p-3 mb-3 rounded-lg bg-gray-50">
                    {/* =============== Your Existing Image Animations (same logic) =============== */}
                    {productImageAnimation === "Auto Scrolling" && product.images.length > 1 ? (
                      <Slider {...settings}>
                        {product.images.map((src, imgIndex) => (
                          <div key={imgIndex} className="relative">
                            <img
                              src={src}
                              alt={product.title}
                              className="object-contain w-full h-40 cursor-pointer"
                              onClick={() =>
                                navigate(`/product-detail/${product.product_auto_id}`)
                              }
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : productImageAnimation === "On Arrow Click" ? (
                      <div className="relative">
                        {/* Left Arrow */}
                        {product.images.length > 1 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePrevImage(product.id);
                            }}
                            className="absolute left-0 z-10 p-2 ml-2 text-white transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full top-1/2"
                          >
                            <RiArrowLeftWideLine />
                          </button>
                        )}

                        <img
                          src={
                            product.images[currentImageIndex[product.id] || 0] ||
                            "https://placehold.co/300x400"
                          }
                          alt={product.title}
                          className="object-contain w-full h-40 cursor-pointer"
                          onClick={() =>
                            navigate(`/product-detail/${product.product_auto_id}`)
                          }
                        />

                        {/* Right Arrow */}
                        {product.images.length > 1 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNextImage(product.id);
                            }}
                            className="absolute right-0 z-10 p-2 mr-2 text-white transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full top-1/2"
                          >
                            <RiArrowRightWideLine />
                          </button>
                        )}
                      </div>
                    ) : productImageAnimation === "On Hover Scrolling" ? (
                      <div
                        className="relative"
                        onMouseEnter={() => handleHoverStart(product.id)}
                        onMouseLeave={() => handleHoverEnd(product.id)}
                      >
                        <img
                          src={
                            product.images[currentImageIndex[product.id] || 0] ||
                            "https://placehold.co/300x400"
                          }
                          alt={product.title}
                          className="object-contain w-full h-40 cursor-pointer"
                          onClick={() =>
                            navigate(`/product-detail/${product.product_auto_id}`)
                          }
                        />
                      </div>
                    ) : (
                      <img
                        src={product.images?.[0] || "https://placehold.co/300x400"}
                        alt={product.title}
                        className="object-contain w-full h-40 cursor-pointer"
                        onClick={() => navigate(`/product-detail/${product.product_auto_id}`)}
                      />
                    )}
                  </div>

                  {/* Delivery Pill (above fresho! and on right side) */}
                  {product.delivery &&
                    product.delivery !== "Delivery time unavailable" &&
                    product.delivery !== "Delivery time unavailabl" && (
                      <div className="flex justify-end mb-2">
                        <div className="hidden md:inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#FFF4D6] text-[#8A6A00] text-xs font-semibold whitespace-nowrap">
                          <FaClock className="text-xs" />
                          <span>{product.delivery}</span>
                        </div>
                      </div>
                    )}

                  {/* Brand */}
                  <p className="mb-1 text-sm text-gray-500">fresho!</p>

                  {/* Product Name */}
                  <h3 className="mb-1 text-sm font-medium leading-snug truncate line-clamp-2">
                    {product.title}
                  </h3>



                  {product.size && product.size.length > 0 && (
                    <select
                      className="px-2 py-1 mb-2 text-sm text-black bg-white border rounded-md"
                      value={selectedSizes[product.id]?.sizeIndex ?? ""}

                      onChange={(e) => {
                        const index = Number(e.target.value);

                        const sizeObj = product.size[index];
                        const priceObj = product.get_price_lists[index];


                        setSelectedSizes((prev) => ({
                          ...prev,
                          [product.id]: {
                            sizeIndex: index,
                            sizeId: sizeObj.size_auto_id, // real ID (for cart)
                            sizeName: sizeObj.size_name,
                            price: Number(priceObj?.final_size_price || product.price.replace("₹", "")),
                            stock: Number(sizeObj.size_stock),

                          },
                        }));
                      }}


                    >
                      <option value="" disabled>
                        Select size
                      </option>

                      {product.size.map((s, index) => (
                        <option
                          key={s.size_auto_id}
                          value={index}
                          disabled={Number(s.size_stock) <= 0}
                        >
                          {s.size_name}
                        </option>
                      ))}
                    </select>
                  )}

                  {/* Price */}
                  <div className="mb-2">
                    <p className="text-sm font-semibold text-black">
                      ₹{selectedSizes[product.id]?.price ?? product.price.replace("₹", "")}

                      {product.originalPrice && (
                        <span className="ml-2 text-gray-400 line-through">
                          {product.originalPrice}
                        </span>
                      )}
                    </p>
                  </div>

                  {/* Bottom Actions */}
                  <div className="flex items-center gap-2 mt-auto">
                    {/* Wishlist */}
                    <button
                      className={`p-1 rounded-full ${vibratingHearts[product.id] ? "vibrate" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFavorite(product.id, product.product_auto_id);
                      }}
                    >
                      {favorites[product.id] ? (
                        <FaHeart className="w-5 h-5 text-red-500 transition-colors duration-200" />
                      ) : (
                        <FaRegHeart className="w-5 h-5 text-gray-500 transition-colors duration-200" />
                      )}
                    </button>

                    {/* Add / Quantity */}
                    <div className="flex-1">
                      {quantities[index] !== undefined ? (
                        <div className="flex items-center justify-between w-full px-2 py-1 border rounded-md">
                          <div className="flex items-center justify-center w-full gap-2">
                            {/* Minus */}
                            <button
                              className="px-2 py-1 border rounded"
                              onClick={() => handleDecrement(index)}
                              style={{ color: themeColor }}
                            >
                              <AiOutlineMinus size={14} />
                            </button>

                            {/* Input */}
                            <input
                              type="number"
                              min="0"
                              value={quantities[index] ?? ""}
                              onChange={async (e) => {
                                const rawValue = e.target.value;

                                if (rawValue === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: "",
                                  }));
                                  return;
                                }

                                const value = parseInt(rawValue);

                                if (!isNaN(value)) {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: value,
                                  }));

                                  const cartItem = cartItems[index];

                                  const productId = cartItem?.product_auto_id;


                                  if (value === 0) {
                                    setQuantities((prev) => {
                                      const updated = { ...prev };
                                      delete updated[index];
                                      return updated;
                                    });

                                    setCartItems((prev) => {
                                      const updated = { ...prev };
                                      delete updated[index];
                                      return updated;
                                    });

                                    if (productId) {
                                      try {
                                        await removeFromCart(productId);
                                      } catch (error) {
                                        console.error("Error removing from cart:", error);
                                      }
                                    }
                                  } else if (cartItem) {
                                    updateCartWithSizeAndPrice(cartItem, value);
                                  }

                                }
                              }}
                              onBlur={() => {
                                if (quantities[index] === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: 1,
                                  }));

                                  const cartItem = cartItems[index];
                                  if (cartItem) {
                                    updateCartWithSizeAndPrice(cartItem, 1);
                                  }

                                }
                              }}
                              className="w-10 text-sm font-semibold text-center bg-transparent outline-none"
                            />

                            {/* Plus */}
                            <button
                              className="px-2 py-1 border rounded"
                              onClick={() => handleIncrement(index)}
                              style={{ color: themeColor }}
                            >
                              <AiOutlinePlus size={14} />
                            </button>
                          </div>
                        </div>
                      ) : (
                        <button
                          className={`w-full py-2 font-semibold border rounded-md ${vibratingCarts[product.id] ? "vibrate" : ""
                            }`}
                          onClick={() => handleAddClick(index)}
                          style={{
                            borderColor: themeColor,
                            color: themeColor,
                            backgroundColor: "transparent",
                          }}
                          onMouseEnter={(e) => {
                            const darkenedColor = darkenHexColor(themeColor, 0.15);
                            e.currentTarget.style.backgroundColor = darkenedColor;
                            e.currentTarget.style.color = "#fff";
                            e.currentTarget.style.borderColor = darkenedColor;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                            e.currentTarget.style.color = themeColor;
                            e.currentTarget.style.borderColor = themeColor;
                          }}
                        >
                          Add
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        )}

        {/* 4 products per row */}
        {productsPerRow === 4 && (
          <div className="container px-1 py-4 mx-auto">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
              {products.map((product, index) => (
                <div
                  key={index}
                  className="relative bg-white border rounded-xl p-3 h-[460px] flex flex-col overflow-hidden"
                >
                  {/* Discount Badge */}
                  {product.discount &&
                    parseFloat(product.discount.replace("% off", "")) > 0 && (
                      <div className="absolute left-0 z-10 px-3 py-1 text-xs font-bold text-white bg-green-700 rounded-r-full top-2">
                        {product.discount}
                      </div>
                    )}

                  {/* IMAGE SECTION */}
                  <div className="relative p-3 mb-3 rounded-lg bg-gray-50">
                    {productImageAnimation === "Auto Scrolling" && product.images.length > 1 ? (
                      <Slider {...settings}>
                        {product.images.map((src, imgIndex) => (
                          <div key={imgIndex} className="relative">
                            <img
                              src={src}
                              alt={product.title}
                              className="object-contain w-full h-40 cursor-pointer"
                              onClick={() =>
                                navigate(`/product-detail/${product.product_auto_id}`)
                              }
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : productImageAnimation === "On Arrow Click" ? (
                      <div className="relative">
                        {/* Left Arrow */}
                        {product.images.length > 1 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePrevImage(product.id);
                            }}
                            className="absolute left-0 z-10 p-2 ml-2 text-white transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full top-1/2"
                          >
                            <RiArrowLeftWideLine />
                          </button>
                        )}

                        <img
                          src={
                            product.images[currentImageIndex[product.id] || 0] ||
                            "https://placehold.co/300x400"
                          }
                          alt={product.title}
                          className="object-contain w-full h-40 cursor-pointer"
                          onClick={() =>
                            navigate(`/product-detail/${product.product_auto_id}`)
                          }
                        />

                        {/* Right Arrow */}
                        {product.images.length > 1 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNextImage(product.id);
                            }}
                            className="absolute right-0 z-10 p-2 mr-2 text-white transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full top-1/2"
                          >
                            <RiArrowRightWideLine />
                          </button>
                        )}
                      </div>
                    ) : productImageAnimation === "On Hover Scrolling" ? (
                      <div
                        className="relative"
                        onMouseEnter={() => handleHoverStart(product.id)}
                        onMouseLeave={() => handleHoverEnd(product.id)}
                      >
                        <img
                          src={
                            product.images[currentImageIndex[product.id] || 0] ||
                            "https://placehold.co/300x400"
                          }
                          alt={product.title}
                          className="object-contain w-full h-40 cursor-pointer"
                          onClick={() =>
                            navigate(`/product-detail/${product.product_auto_id}`)
                          }
                        />
                      </div>
                    ) : (
                      <img
                        src={product.images?.[0] || "https://placehold.co/300x400"}
                        alt={product.title}
                        className="object-contain w-full h-40 cursor-pointer"
                        onClick={() => navigate(`/product-detail/${product.product_auto_id}`)}
                      />
                    )}
                  </div>

                  {/* Delivery Pill (above fresho! and right aligned) */}
                  {product.delivery &&
                    product.delivery !== "Delivery time unavailable" &&
                    product.delivery !== "Delivery time unavailabl" && (
                      <div className="flex justify-end mb-2">
                        <div className="hidden md:inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#FFF4D6] text-[#8A6A00] text-xs font-semibold whitespace-nowrap">
                          <AiFillThunderbolt className="text-xs" />
                          <span>{product.delivery}</span>
                        </div>
                      </div>
                    )}

                  {/* Brand */}
                  <p className="mb-1 text-sm text-gray-500">fresho!</p>

                  {/* Title */}
                  <h2 className="mb-1 text-sm font-medium leading-snug truncate line-clamp-2">
                    {product.title}
                  </h2>



                  {product.size && product.size.length > 0 && (
                    <select
                      className="px-2 py-1 mb-2 text-sm text-black bg-white border rounded-md"
                      value={selectedSizes[product.id]?.sizeIndex ?? ""}

                      onChange={(e) => {
                        const index = Number(e.target.value);

                        const sizeObj = product.size[index];
                        const priceObj = product.get_price_lists[index];


                        setSelectedSizes((prev) => ({
                          ...prev,
                          [product.id]: {
                            sizeIndex: index,
                            sizeId: sizeObj.size_auto_id, // real ID (for cart)
                            sizeName: sizeObj.size_name,
                            price: Number(priceObj?.final_size_price || product.price.replace("₹", "")),
                            stock: Number(sizeObj.size_stock),

                          },
                        }));
                      }}


                    >
                      <option value="" disabled>
                        Select size
                      </option>

                      {product.size.map((s, index) => (
                        <option
                          key={s.size_auto_id}
                          value={index}
                          disabled={Number(s.size_stock) <= 0}
                        >
                          {s.size_name}
                        </option>
                      ))}
                    </select>
                  )}

                  {/* Price */}
                  <div className="mb-2">
                    <p className="text-sm font-semibold text-black">
                      ₹{selectedSizes[product.id]?.price ?? product.price.replace("₹", "")}

                      {product.originalPrice && (
                        <span className="ml-2 text-gray-400 line-through">
                          {product.originalPrice}
                        </span>
                      )}
                    </p>
                  </div>

                  {/* Bottom Actions */}
                  <div className="flex items-center gap-2 mt-auto">
                    {/* Wishlist moved to bottom (same logic) */}
                    <button
                      className={`p-1 rounded-full ${vibratingHearts[product.id] ? "vibrate" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFavorite(product.id, product.product_auto_id);
                      }}
                    >
                      {favorites[product.id] ? (
                        <FaHeart className="w-5 h-5 text-red-500 transition-colors duration-200" />
                      ) : (
                        <FaRegHeart className="w-5 h-5 text-gray-500 transition-colors duration-200" />
                      )}
                    </button>

                    {/* Add / Quantity (same logic, new UI) */}
                    <div className="flex-1">
                      {quantities[index] !== undefined ? (
                        <div className="flex items-center justify-between w-full px-2 py-1 border rounded-md">
                          <div className="flex items-center justify-center w-full gap-2">
                            <button
                              className="px-2 py-1 border rounded"
                              onClick={() => handleDecrement(index)}
                              style={{ color: themeColor }}
                            >
                              <AiOutlineMinus size={14} />
                            </button>

                            <input
                              type="number"
                              min="0"
                              value={quantities[index] ?? ""}
                              onChange={async (e) => {
                                const rawValue = e.target.value;

                                if (rawValue === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: "",
                                  }));
                                  return;
                                }

                                const value = parseInt(rawValue);

                                if (!isNaN(value)) {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: value,
                                  }));

                                  const cartItem = cartItems[index];

                                  const productId = cartItem?.product_auto_id;


                                  if (value === 0) {
                                    setQuantities((prev) => {
                                      const updated = { ...prev };
                                      delete updated[index];
                                      return updated;
                                    });

                                    setCartItems((prev) => {
                                      const updated = { ...prev };
                                      delete updated[index];
                                      return updated;
                                    });

                                    if (productId) {
                                      try {
                                        await removeFromCart(productId);
                                      } catch (error) {
                                        console.error("Error removing from cart:", error);
                                      }
                                    }
                                  } else if (cartItem) {
                                    updateCartWithSizeAndPrice(cartItem, value);
                                  }

                                }
                              }}
                              onBlur={() => {
                                if (quantities[index] === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: 1,
                                  }));

                                  const cartItem = cartItems[index];
                                  if (cartItem) {
                                    updateCartWithSizeAndPrice(cartItem, 1);
                                  }

                                }
                              }}
                              className="w-10 text-sm font-semibold text-center bg-transparent outline-none"
                            />

                            <button
                              className="px-2 py-1 border rounded"
                              onClick={() => handleIncrement(index)}
                              style={{ color: themeColor }}
                            >
                              <AiOutlinePlus size={14} />
                            </button>
                          </div>
                        </div>
                      ) : (
                        <button
                          className={`w-full py-2 font-semibold border rounded-md ${vibratingCarts[product.id] ? "vibrate" : ""
                            }`}
                          onClick={() => handleAddClick(index)}
                          style={{
                            borderColor: themeColor,
                            color: themeColor,
                            backgroundColor: "transparent",
                          }}
                          onMouseEnter={(e) => {
                            const darkenedColor = darkenHexColor(themeColor, 0.15);
                            e.currentTarget.style.backgroundColor = darkenedColor;
                            e.currentTarget.style.color = "#fff";
                            e.currentTarget.style.borderColor = darkenedColor;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                            e.currentTarget.style.color = themeColor;
                            e.currentTarget.style.borderColor = themeColor;
                          }}
                        >
                          Add
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        )}

        {/* 5  products per row */}
        {productsPerRow === 5 && (
          <div className="container px-1 py-4 mx-auto">
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
              {products.map((product, index) => (
                <div
                  key={index}
                  className="relative bg-white border rounded-xl p-3 h-[460px] flex flex-col overflow-hidden"
                >
                  {/* Discount Badge */}
                  {product.discount &&
                    parseFloat(product.discount.replace("% off", "")) > 0 && (
                      <div className="absolute left-0 z-10 px-3 py-1 text-xs font-bold text-white bg-green-700 rounded-r-full top-2">
                        {product.discount}
                      </div>
                    )}

                  {/* IMAGE SECTION */}
                  <div className="relative p-3 mb-3 rounded-lg bg-gray-50">
                    {productImageAnimation === "Auto Scrolling" && product.images.length > 1 ? (
                      <Slider {...settings}>
                        {product.images.map((src, imgIndex) => (
                          <div key={imgIndex} className="relative">
                            <img
                              src={src}
                              alt={product.title}
                              className="object-contain w-full h-40 cursor-pointer"
                              onClick={() =>
                                navigate(`/product-detail/${product.product_auto_id}`)
                              }
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : productImageAnimation === "On Arrow Click" ? (
                      <div className="relative">
                        {/* Left Arrow */}
                        {product.images.length > 1 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePrevImage(product.id);
                            }}
                            className="absolute left-0 z-10 p-2 ml-2 text-white transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full top-1/2"
                          >
                            <RiArrowLeftWideLine />
                          </button>
                        )}

                        <img
                          src={
                            product.images[currentImageIndex[product.id] || 0] ||
                            "https://placehold.co/300x400"
                          }
                          alt={product.title}
                          className="object-contain w-full h-40 cursor-pointer"
                          onClick={() =>
                            navigate(`/product-detail/${product.product_auto_id}`)
                          }
                        />

                        {/* Right Arrow */}
                        {product.images.length > 1 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNextImage(product.id);
                            }}
                            className="absolute right-0 z-10 p-2 mr-2 text-white transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full top-1/2"
                          >
                            <RiArrowRightWideLine />
                          </button>
                        )}
                      </div>
                    ) : productImageAnimation === "On Hover Scrolling" ? (
                      <div
                        className="relative"
                        onMouseEnter={() => handleHoverStart(product.id)}
                        onMouseLeave={() => handleHoverEnd(product.id)}
                      >
                        <img
                          src={
                            product.images[currentImageIndex[product.id] || 0] ||
                            "https://placehold.co/300x400"
                          }
                          alt={product.title}
                          className="object-contain w-full h-40 cursor-pointer"
                          onClick={() =>
                            navigate(`/product-detail/${product.product_auto_id}`)
                          }
                        />
                      </div>
                    ) : (
                      <img
                        src={product.images?.[0] || "https://placehold.co/300x400"}
                        alt={product.title}
                        className="object-contain w-full h-40 cursor-pointer"
                        onClick={() => navigate(`/product-detail/${product.product_auto_id}`)}
                      />
                    )}
                  </div>

                  {/* Delivery Pill (above fresho! and on right side) */}
                  {product.delivery &&
                    product.delivery !== "Delivery time unavailable" &&
                    product.delivery !== "Delivery time unavailabl" && (
                      <div className="flex justify-end mb-2">
                        <div className="hidden md:inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#FFF4D6] text-[#8A6A00] text-xs font-semibold whitespace-nowrap">
                          <AiFillThunderbolt className="text-xs" />
                          <span>{product.delivery}</span>
                        </div>
                      </div>
                    )}

                  {/* Brand */}
                  <p className="mb-1 text-sm text-gray-500">fresho!</p>

                  {/* Product Title */}
                  <h2 className="mb-1 text-sm font-medium leading-snug truncate line-clamp-2">
                    {product.title}
                  </h2>



                  {product.size && product.size.length > 0 && (
                    <select
                      className="px-2 py-1 mb-2 text-sm text-black bg-white border rounded-md"
                      value={selectedSizes[product.id]?.sizeIndex ?? ""}

                      onChange={(e) => {
                        const index = Number(e.target.value);

                        const sizeObj = product.size[index];
                        const priceObj = product.get_price_lists[index];


                        setSelectedSizes((prev) => ({
                          ...prev,
                          [product.id]: {
                            sizeIndex: index,
                            sizeId: sizeObj.size_auto_id, // real ID (for cart)
                            sizeName: sizeObj.size_name,
                            price: Number(priceObj?.final_size_price || product.price.replace("₹", "")),
                            stock: Number(sizeObj.size_stock),

                          },
                        }));
                      }}


                    >
                      <option value="" disabled>
                        Select size
                      </option>

                      {product.size.map((s, index) => (
                        <option
                          key={s.size_auto_id}
                          value={index}
                          disabled={Number(s.size_stock) <= 0}
                        >
                          {s.size_name}
                        </option>
                      ))}
                    </select>
                  )}

                  {/* Price */}
                  <div className="mb-2">
                    <p className="text-sm font-semibold text-black">
                      ₹{selectedSizes[product.id]?.price ?? product.price.replace("₹", "")}

                      {product.originalPrice && (
                        <span className="ml-2 text-gray-400 line-through">
                          {product.originalPrice}
                        </span>
                      )}
                    </p>
                  </div>

                  {/* Bottom Actions (Wishlist + Add/Qty) */}
                  <div className="flex items-center gap-2 mt-auto">
                    {/* Wishlist */}
                    <button
                      className={`p-1 rounded-full ${vibratingHearts[product.id] ? "vibrate" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFavorite(product.id, product.product_auto_id);
                      }}
                    >
                      {favorites[product.id] ? (
                        <FaHeart className="w-5 h-5 text-red-500 transition-colors duration-200" />
                      ) : (
                        <FaRegHeart className="w-5 h-5 text-gray-500 transition-colors duration-200" />
                      )}
                    </button>

                    {/* Add / Quantity */}
                    <div className="flex-1">
                      {quantities[index] !== undefined ? (
                        <div className="flex items-center justify-between w-full px-2 py-1 border rounded-md">
                          <div className="flex items-center justify-center w-full gap-2">
                            {/* Minus */}
                            <button
                              className="px-2 py-1 border rounded"
                              onClick={() => handleDecrement(index)}
                              style={{ color: themeColor }}
                            >
                              <AiOutlineMinus size={14} />
                            </button>

                            {/* Quantity input */}
                            <input
                              type="number"
                              min="0"
                              value={quantities[index] ?? ""}
                              onChange={async (e) => {
                                const rawValue = e.target.value;

                                if (rawValue === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: "",
                                  }));
                                  return;
                                }

                                const value = parseInt(rawValue);

                                if (!isNaN(value)) {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: value,
                                  }));

                                  const cartItem = cartItems[index];

                                  const productId = cartItem?.product_auto_id;


                                  if (value === 0) {
                                    setQuantities((prev) => {
                                      const updated = { ...prev };
                                      delete updated[index];
                                      return updated;
                                    });

                                    setCartItems((prev) => {
                                      const updated = { ...prev };
                                      delete updated[index];
                                      return updated;
                                    });

                                    if (productId) {
                                      try {
                                        await removeFromCart(productId);
                                      } catch (error) {
                                        console.error("Error removing from cart:", error);
                                      }
                                    }
                                  } else if (cartItem) {
                                    updateCartWithSizeAndPrice(cartItem, value);
                                  }

                                }
                              }}
                              onBlur={() => {
                                if (quantities[index] === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [index]: 1,
                                  }));

                                  const cartItem = cartItems[index];
                                  if (cartItem) {
                                    updateCartWithSizeAndPrice(cartItem, 1);
                                  }

                                }
                              }}
                              className="w-10 text-sm font-semibold text-center bg-transparent outline-none"
                            />

                            {/* Plus */}
                            <button
                              className="px-2 py-1 border rounded"
                              onClick={() => handleIncrement(index)}
                              style={{ color: themeColor }}
                            >
                              <AiOutlinePlus size={14} />
                            </button>
                          </div>
                        </div>
                      ) : (
                        <button
                          className={`w-full py-2 font-semibold border rounded-md ${vibratingCarts[product.id] ? "vibrate" : ""
                            }`}
                          onClick={() => handleAddClick(index)}
                          style={{
                            borderColor: themeColor,
                            color: themeColor,
                            backgroundColor: "transparent",
                          }}
                          onMouseEnter={(e) => {
                            const darkenedColor = darkenHexColor(themeColor, 0.15);
                            e.currentTarget.style.backgroundColor = darkenedColor;
                            e.currentTarget.style.color = "#fff";
                            e.currentTarget.style.borderColor = darkenedColor;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                            e.currentTarget.style.color = themeColor;
                            e.currentTarget.style.borderColor = themeColor;
                          }}
                        >
                          Add
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        )}
      </div>
      {isLoginModalOpen && (
        <Login isOpen={isLoginModalOpen} onClose={closeLoginModal} />
      )}
    </div>
  );
}